import { render, staticRenderFns } from "./UserAccessNew.vue?vue&type=template&id=699aa75d&lang=pug"
import script from "./UserAccessNew.vue?vue&type=script&lang=js"
export * from "./UserAccessNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('699aa75d')) {
      api.createRecord('699aa75d', component.options)
    } else {
      api.reload('699aa75d', component.options)
    }
    module.hot.accept("./UserAccessNew.vue?vue&type=template&id=699aa75d&lang=pug", function () {
      api.rerender('699aa75d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/UserAccessNew.vue"
export default component.exports